var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialmediaGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Proximo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1934_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_682_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M14,44C8.48584,44,4,39.51367,4,34s4.48584-10,10-10s10,4.48633,10,10S19.51416,44,14,44z M14,26 c-4.41113,0-8,3.58887-8,8s3.58887,8,8,8s8-3.58887,8-8S18.41113,26,14,26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_684_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M23,64H5c-2.75684,0-5-2.24316-5-5v-3c0-7.71973,6.28027-14,14-14s14,6.28027,14,14v3 C28,61.75684,25.75684,64,23,64z M14,44C7.3833,44,2,49.38281,2,56v3c0,1.6543,1.3457,3,3,3h18c1.6543,0,3-1.3457,3-3v-3 C26,49.38281,20.6167,44,14,44z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_534_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M10.02588,48.92676c-0.36865,0-0.72363-0.2041-0.89746-0.55762 c-0.24463-0.49512-0.0415-1.09473,0.45361-1.33887c0.17334-0.08594,0.34863-0.16699,0.52637-0.24219 c0.50977-0.21875,1.0957,0.01953,1.31152,0.52832c0.21631,0.50781-0.02002,1.0957-0.52832,1.31152 c-0.14355,0.06152-0.28467,0.12695-0.42383,0.19531C10.3252,48.89355,10.17432,48.92676,10.02588,48.92676z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_535_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M5,57c-0.55225,0-1-0.44727-1-1c0-1.34766,0.26514-2.65625,0.7876-3.89063 c0.42627-1.00586,1.01367-1.93262,1.74512-2.75488c0.36719-0.41211,0.99902-0.4502,1.41211-0.08203 c0.4126,0.36719,0.44922,1,0.08203,1.41211c-0.58643,0.6582-1.05664,1.40039-1.39746,2.20508C6.21191,53.875,6,54.92188,6,56 C6,56.55273,5.55225,57,5,57z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_683_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M50,44c-5.51416,0-10-4.48633-10-10s4.48584-10,10-10s10,4.48633,10,10S55.51416,44,50,44z M50,26 c-4.41113,0-8,3.58887-8,8s3.58887,8,8,8s8-3.58887,8-8S54.41113,26,50,26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_685_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M59,64H41c-2.75684,0-5-2.24316-5-5v-3c0-7.71973,6.28027-14,14-14s14,6.28027,14,14v3 C64,61.75684,61.75684,64,59,64z M50,44c-6.6167,0-12,5.38281-12,12v3c0,1.6543,1.3457,3,3,3h18c1.6543,0,3-1.3457,3-3v-3 C62,49.38281,56.6167,44,50,44z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_545_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M46.03223,48.92285c-0.37012,0-0.72607-0.20605-0.89941-0.56055 c-0.24268-0.49609-0.03711-1.0957,0.45898-1.33789c0.16992-0.08301,0.34229-0.16211,0.51758-0.2373 c0.5083-0.21387,1.0957,0.02246,1.31104,0.53027c0.21582,0.50781-0.021,1.0957-0.52979,1.31152 c-0.14209,0.05957-0.28223,0.125-0.41992,0.19238C46.3291,48.89063,46.1792,48.92285,46.03223,48.92285z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_544_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M41,57c-0.55225,0-1-0.44727-1-1c0-1.34766,0.26514-2.65625,0.7876-3.89063 c0.42627-1.00488,1.01221-1.93066,1.7417-2.75098c0.36572-0.41211,0.99854-0.45117,1.41162-0.08203 c0.4126,0.36719,0.44971,0.99902,0.08252,1.41211c-0.58398,0.65625-1.05322,1.39746-1.39404,2.20215 C42.21191,53.875,42,54.92188,42,56C42,56.55273,41.55225,57,41,57z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_691_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M43,24c-0.29248,0-0.5752-0.12891-0.76807-0.35938L37.53174,18H26.46826l-4.7002,5.64063 c-0.25098,0.29883-0.65576,0.4248-1.02979,0.32422c-0.37744-0.10156-0.66064-0.41504-0.72461-0.80078L19.15283,18H10 c-1.6543,0-3-1.3457-3-3V3c0-1.6543,1.3457-3,3-3h44c1.6543,0,3,1.3457,3,3v12c0,1.6543-1.3457,3-3,3h-9.15283l-0.86084,5.16406 c-0.06396,0.38574-0.34717,0.69922-0.72461,0.80078C43.17529,23.98828,43.08691,24,43,24z M26,16h12 c0.29688,0,0.57813,0.13184,0.76807,0.35938l3.604,4.3252l0.6416-3.84863C43.09375,16.35352,43.51123,16,44,16h10 c0.55127,0,1-0.44824,1-1V3c0-0.55176-0.44873-1-1-1H10C9.44873,2,9,2.44824,9,3v12c0,0.55176,0.44873,1,1,1h10 c0.48877,0,0.90625,0.35352,0.98633,0.83594l0.6416,3.84863l3.604-4.3252C25.42188,16.13184,25.70313,16,26,16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_686_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M45,8H19c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h26c0.55225,0,1,0.44727,1,1S45.55225,8,45,8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_689_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M37,12H19c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h18c0.55225,0,1,0.44727,1,1S37.55225,12,37,12z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_690_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M45,12c-0.26025,0-0.52002-0.11035-0.70996-0.29004C44.10986,11.51953,44,11.25977,44,11 s0.10986-0.52051,0.29004-0.70996c0.36963-0.37012,1.0498-0.37012,1.41992,0C45.88965,10.47949,46,10.74023,46,11 s-0.11035,0.51953-0.29004,0.70996C45.52002,11.88965,45.25977,12,45,12z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_439_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M41,12c-0.26025,0-0.52002-0.11035-0.70996-0.29004C40.10986,11.51953,40,11.26953,40,11 c0-0.27051,0.10986-0.52051,0.29004-0.70996c0.36963-0.37012,1.0498-0.37012,1.41992,0C41.88965,10.47949,42,10.74023,42,11 s-0.11035,0.51953-0.29004,0.70996C41.52002,11.88965,41.27002,12,41,12z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_533_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M32,35c-0.26025,0-0.52002-0.11035-0.70996-0.29004C31.10986,34.51953,31,34.25977,31,34 s0.10986-0.52051,0.29004-0.70996c0.36963-0.37012,1.0498-0.37012,1.41992,0C32.88965,33.47949,33,33.74023,33,34 s-0.11035,0.51953-0.29004,0.70996C32.52002,34.88965,32.25977,35,32,35z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_546_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M28,35c-0.26025,0-0.52002-0.11035-0.70996-0.29004C27.10986,34.51953,27,34.25977,27,34 s0.10986-0.52051,0.29004-0.70996c0.36963-0.37012,1.0498-0.37012,1.41992,0C28.88965,33.46973,29,33.72949,29,34 c0,0.26953-0.11035,0.51953-0.29004,0.70996C28.52002,34.88965,28.25977,35,28,35z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_552_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M36,35c-0.26025,0-0.52002-0.11035-0.70996-0.29004C35.10986,34.51953,35,34.25977,35,34 s0.10986-0.52051,0.29004-0.70996c0.37988-0.37012,1.0498-0.37012,1.41992,0C36.88965,33.47949,37,33.72949,37,34 c0,0.25977-0.11035,0.51953-0.29004,0.70996C36.52002,34.88965,36.25977,35,36,35z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialmediaGrey);
export default __webpack_public_path__ + "static/media/socialmedia_grey.1e5bb867dfc09c6f0fa41d50e83c12ad.svg";
export { ForwardRef as ReactComponent };